import { render, staticRenderFns } from "./appointshop.vue?vue&type=template&id=0f930a53&scoped=true&"
import script from "./appointshop.vue?vue&type=script&lang=js&"
export * from "./appointshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f930a53",
  null
  
)

export default component.exports